import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/addNews.css";
import { CardRotate } from "../../_components/CardRotate";
import { formatDate } from "../../_helpers/formatDate";
import { BtnRound } from "../../_components/BtnRound";

class ShowNews_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      type: "",
      description: "",
      subtitle: "",
      author: "",
      status: "",
      newsPosted: false,
      postedNewsID: null,
      postedNewsDate: null,
      postedImageDate: null,
      images: [],
      weHaveImgMain: false,
      type_options: [
        { id: 1, name: "داخلی" },
        { id: 2, name: "عمومی" },
        { id: 3, name: "روابط عمومی" },
        { id: 4, name: "اخبار بیمارستان" },
        { id: 5, name: "مقاله پزشکی" },
        { id: 6, name: "آموزش پزشکی" },
      ],
    };
    this.globalStorage = this.props.globalStorage;
    this.config = {
      headers: {
        Authorization: JSON.parse(localStorage.getItem("tokenAdmin")),
      },
    };
  }

  componentDidMount = () => {
    document.querySelector(".logout-btn").classList.add("hidden");
    document.querySelector(".logout-btn-bg").classList.add("hidden");

    const { title, subtitle, category, body, author, status, id } =
      this.props.data;
    this.setState(
      {
        title: title || "",
        subtitle: subtitle || "",
        type:
          this.state.type_options.find((type) => type.id === Number(category))
            .name || "",
        description: body || "",
        author: author || "",
        status: status,
        postedNewsID: id,
      },
      this.getImages
    );
  };

  componentWillUnmount = () => {
    this.reset();
    document.querySelector(".logout-btn").classList.remove("hidden");
    document.querySelector(".logout-btn-bg").classList.remove("hidden");
  };

  reset = () => {
    this.setState({
      title: "",
      type: "",
      description: "",
      subtitle: "",
      author: "",
      status: "",
      newsPosted: false,
      postedNewsID: null,
      postedNewsDate: null,
      postedImageDate: null,
      images: [],
      weHaveImgMain: false,
    });
  };

  getImages = () => {
    const { postedNewsID } = this.state;

    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/announcements/${postedNewsID}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          postedNewsDate: res.data.created_at,
          postedImageDate: res.data.updated_at,
          images: res.data.images,
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    const {
      description,
      title,
      type,
      subtitle,
      author,
      newsPosted,
      postedNewsDate,
      postedImageDate,
      images,
    } = this.state;
    const { onClose } = this.props;
    let eventTitle = this.props.title ? this.props.title : "";
    const dates = [postedNewsDate, postedImageDate, null];
    const names = ["محتوا", "عکس ها", "نمایش نهایی"];
    const labels = ["محتوا", "عکس ها", "نمایش نهایی"];

    return (
      <Container className="container_shownew">
        <>
          <Title text={`پیش نمایش ${eventTitle}`} />
          <div className="row mb-2">
            <div className="col-lg-12">
              <NotifCard text1="این صفحه پیش نمایش می باشد در صورت نیاز به ویرایش از دکمه ویرایش استفاده کنید." />
            </div>
          </div>
          {postedNewsDate ? (
            <Timeline dates={dates} names={names} labels={labels} />
          ) : (
            ""
          )}
          <div className="w-100 d-inline-block mt-2">
            <p className="text-right pr-3 iran-sans_Bold mt-3 shownew text_style">{`عنوان ${eventTitle}`}</p>
            <Input value={title} onChange={() => ""} />
          </div>

          <div className="w-100 d-inline-block mt-2">
            <p className="text-right pr-3 iran-sans_Bold mt-3 shownew text_style">
              دسته بندی
            </p>
            <Input value={type} onChange={() => ""} />
          </div>

          <div className="w-100 d-inline-block mt-2">
            <p className="text-right pr-3 iran-sans_Bold mt-3 shownew text_style">{`مختصری از ${eventTitle}`}</p>
            <Input value={type} onChange={() => ""} />
          </div>

          <div className="w-100 d-inline-block mt-2">
            <p className="text-right pr-3 iran-sans_Bold mt-3 shownew text_style">{`شرح کامل ${eventTitle}`}</p>
            <Input value={type} onChange={() => ""} />
          </div>

          <div className="w-100 d-inline-block mt-2">
            <p className="text-right pr-3 iran-sans_Bold mt-3 shownew text_style">
              نویسنده
            </p>
            <Input value={type} onChange={() => ""} />
          </div>

          <div className="row">
            <div className="col-lg-12 indexSec timeline mx-auto">
              {images.length !== 0 && (
                <div
                  className="border-0 h-100 d-flex align-items-center justify-content-center mb-3"
                  style={{ gap: "10px", flexWrap: "wrap" }}
                >
                  {images.map((image, i) => {
                    const { file, main, announcement_id, id } = image;
                    return (
                      <CardRotate
                        style={{
                          outline: main ? "5px solid #FFD700" : 0,
                        }}
                        className={`${main ? "cover-main" : ""}`}
                        backStyle={{ display: "none" }}
                        background={`${userConstants.SERVER_URL}${file.url}`}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="btn rounded-pill py-2 d-flex justify-content-center mx-auto mt-3 btn_empty mb-0"
          >
            بازگشت
          </button>
        </>
      </Container>
    );
  }
}

class Container extends Component {
  render() {
    return (
      <div className="login-admin">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 addNews">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Input extends Component {
  render() {
    const { value, onChange } = this.props;
    return (
      <input
        name="name"
        type="text"
        className="form-control"
        aria-label="Full Name"
        value={value}
        onChange={onChange}
      />
    );
  }
}

// class SelectType extends Component {
//   render() {
//     const { value, onChange, options, placeholder } = this.props;
//     const selectStyle = {
//       container: (baseStyles) => ({
//         ...baseStyles,
//         height: "50px",
//       }),
//       control: (baseStyles) => ({
//         ...baseStyles,
//         background: "#e8e8e8",
//         border: "none",
//         padding: "6px 10px 6px 5px",
//         height: "100%",
//       }),
//       menu: (baseStyles) => ({
//         ...baseStyles,
//         zIndex: "999",
//         textAlign: "right",
//       }),
//     };

//     return (
//       <Select
//         styles={selectStyle}
//         value={value}
//         onChange={onChange}
//         options={options}
//         placeholder={placeholder}
//         getOptionLabel={(opt) => opt.name}
//         getOptionValue={(opt) => opt.id}
//       />
//     );
//   }
// }

class Textarea extends Component {
  render() {
    const { value, onChange } = this.props;
    return (
      <textarea
        className="special-textarea"
        value={value}
        onChange={onChange}
      />
    );
  }
}

class Title extends Component {
  render() {
    const { text } = this.props;
    return (
      <div className="addNews__banner">
        <p>{text}</p>
      </div>
    );
  }
}

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.dates.filter((date) => date !== null).length - 1,
      previous: 0,
    };
  }

  render() {
    const { dates, names, labels } = this.props;
    const { value } = this.state;

    return (
      <div className="row timelineParent">
        <div className="col-xl-12 col-lg-12 col-md-11 col-sm-10 indexSec timeline mx-auto mb-3">
          <div className="border-0 h-100 ">
            <div
              className="card border-0 shadow-smm"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body" style={{ height: "270px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                    margin: "0 auto 70px auto",
                  }}
                >
                  <div className="text-center title">
                    <span>
                      نـوار اعلام وضعیت نیازسنجی هـای درخـواست شـده توسـط شمـا
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-12 py-5 d-flex flex-row-reverse justify-content-center align-items-center gap-sm">
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 0 ? "bg-primary" : "bg-gray"
                          } basic-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 0 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 0 ? "text-primary" : ""
                          }`}
                        >
                          {names[0]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 1 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 1 ? "bg-primary" : "bg-gray"
                          } payesh-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 1 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 1 ? "text-primary" : ""
                          }`}
                        >
                          {names[1]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 2 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 2 ? "bg-primary" : "bg-gray"
                          } question-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 2 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 2 ? "text-primary" : ""
                          }`}
                        >
                          {names[2]}
                        </p>
                      </div>
                    </div>
                  </div>
                  {dates[value] !== null ? (
                    value === 0 ? (
                      <p className="mb-0 text-center">
                        {`${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {`ثبت شد .`}
                      </p>
                    ) : value === 1 ? (
                      <p className="mb-0 text-center">
                        {`${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {`ثبت شد .`}
                      </p>
                    ) : (
                      <p className="mb-0 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    )
                  ) : (
                    <p className="mb-0 text-center">
                      این مرحله هنوز تکمیل نشده است
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class NotifCard extends Component {
  render() {
    const { text1, text2, color1 = "#777777", color2 = "#6c00ff" } = this.props;

    return (
      <p className="notif py-3 px-5">
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </p>
    );
  }
}

const ShowNews = connect((state) => ({
  globalStorage: state.globalStorage,
}))(ShowNews_);

export { ShowNews };
